export const MODAL_NAME = 'Onboarding'

export const ONBOARDING_QUERY_VALUE = 'OK'
